module.exports = __webpack_public_path__ + "img/thumbnail_Bonobo_f_normal.85a1601c.png";